export const PatientTypeConstants = {
    
    
    REGISTER_PATIENT_REQUEST: 'REGISTER_PATIENT_REQUEST',
    REGISTER_PATIENT_SUCCESS: 'REGISTER_PATIENT_SUCCESS',
    REGISTER_PATIENT_FAILURE: 'REGISTER_PATIENT_FAILURE',
    
    UPDATE_PATIENT_REQUEST: 'UPDATE_PATIENT_REQUEST',
    UPDATE_PATIENT_SUCCESS: 'UPDATE_PATIENT_SUCCESS',
    UPDATE_PATIENT_FAILURE: 'UPDATE_PATIENT_FAILURE',

    UPDATE_PATIENT_ADDRESS_REQUEST: 'UPDATE_PATIENTI_ADDRESS_REQUEST',
    
    UPDATE_PATIENT_INS_INFO_REQUEST: 'UPDATE_PATIENT_INS_INFO_REQUEST',
    
    PATIENT_APPOINTMENT_REQUEST : 'PATIENT_APPOINTMENT_REQUEST' ,
    PATIENT_APPOINTMENT_SUCCESS : 'PATIENT_APPOINTMENT_SUCCESS' ,
    PATIENT_APPOINTMENT_FAILIURE : 'PATIENT_APPOINTMENT_FAILIURE',
    
    GET_ALL_PATIENT_REQUEST : 'GET_ALL_PATIENT_REQUEST' ,
    GET_ALL_PATIENT_SUCCESS : 'GET_ALL_PATIENT_SUCCESS' ,
    GET_ALL_PATIENT_FAILIURE : 'GET_ALL_PATIENT_FAILIURE',

    GET_PATIENT_BY_ID_REQUEST : 'GET_PATIENT_BY_ID_REQUEST' ,
    GET_PATIENT_BY_ID_SUCCESS : 'GET_PATIENT_BY_ID_SUCCESS' ,
    GET_PATIENT_BY_ID_FAILIURE : 'GET_PATIENT_BY_ID_FAILIURE',


    SEARCH_PATIENT_REQUEST : 'SEARCH_PATIENT_REQUEST',
    SEARCH_PATIENT_SUCCESS : 'SEARCH_PATIENT_SUCCESS',
    SEARCH_PATIENT_FAILIURE : 'SEARCH_PATIENT_FAILIURE',

    UPDATE_PATIENT_REGISTRATION_FLAG:'UPDATE_PATIENT_REGISTRATION_FLAG',
    ADD_NEW_PATIENT : 'ADD_NEW_PATIENT',
    GET_ALL_ACTIVE_PATIENT_REQUEST:'GET_ALL_ACTIVE_PATIENT_REQUEST',
    SEND_SMS_TO_PATIENT:'SEND_SMS_TO_PATIENT',
    PATIENT_CLEAR_ALL:'PATIENT_CLEAR_ALL',

};